import Client from './client';

export default class InternalPaymentRequests extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/payment/requests/${id}/internal`, options);
  }

  postPaymentAndMethodAndData(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/payment/requests/${id}/internal/payment/method/data`, {
      ...options,
       method: 'POST',
    });
  }

  postPaymentMethodData(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/payment/requests/${id}/internal/payment_method_data`, {
      ...options,
       method: 'POST',
    });
  }

}
